import dayjs from 'dayjs';
import { isNil } from 'lodash';

export const getAverage = ({
  totalScore,
  gamesPlayed,
}: {
  totalScore: number;
  gamesPlayed: number;
}): number => {
  return gamesPlayed === 0 ? 0 : Math.round(totalScore / gamesPlayed);
};

/**
 * Streak in database is only updated after a game has been completed,
 * to show the user their correct streak we need to see when they last played
 *
 * currentStreak is only valid if the lastGamePlayed is today or yesterday
 */
export const getStreak = ({
  currentStreak,
  lastGamePlayed,
}: {
  currentStreak: number;
  lastGamePlayed: string | null;
}): number => {
  if (isNil(lastGamePlayed)) return 0;

  const today = dayjs();
  if (
    dayjs(lastGamePlayed).isSame(today, 'day') ||
    dayjs(lastGamePlayed).add(1, 'day').isSame(today, 'day')
  ) {
    return currentStreak;
  } else {
    return 0;
  }
};
